import * as React from "react";
import type { SVGProps } from "react";
const SvgWalletIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="wallet_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M170.667 128a85.333 85.333 0 0 0-85.334 85.333v597.334A85.333 85.333 0 0 0 170.667 896h682.666a85.333 85.333 0 0 0 85.334-85.333V213.333A85.333 85.333 0 0 0 853.333 128H170.667zm682.666 256h-128a128 128 0 1 0 0 256h128v170.667H170.667V213.333h682.666V384zm0 170.667h-128a42.667 42.667 0 1 1 0-85.334h128v85.334z"
    />
  </svg>
);
export default SvgWalletIcon;
